import React, {useEffect, useState} from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import s from './pieChart.module.scss';
import { colorList } from "../../../../../utils/vars/staticVariables";
import {useSelector} from "react-redux";
import {dashboardSelector} from "../../../../../redux/slices/dashboardSlice";
import {globalDataSelector} from "../../../../../redux/slices/globalDataSlice";
import {useWindowWidth} from "../../../../../hooks/useWindowWidth";

const CustomTooltip = ({ payload, active, coordinate }) => {
    if (active && payload && payload.length) {
        const { name, value } = payload[0];
        const xPos = coordinate.x < 150 ? coordinate.x + 20 : coordinate.x - 150;

        return (
            <div
                className={s.customTooltip}
                style={{
                    left: `${xPos}px`,
                    top: `${coordinate.y + 50}px`,
                }}
            >
                <p>{`${name}: ${value}%`}</p>
            </div>
        );
    }
    return null;
};

const CirclePieChart = () => {
    const [chartSize, setChartSize] = useState({
        width: 530,
        height: 400,
        outerRadius: 150
    });

    const windowWidth = useWindowWidth();

    const {topGeosList, topGeosPending} = useSelector(dashboardSelector)
    const {geoList} =
        useSelector(globalDataSelector);

    const geosData = topGeosList.map(item => ({value: item.percentage, name: geoList.find(
            (geoItem) => geoItem.code === item.geo,
        )?.name}))

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;

            if (screenWidth < 600) {
                setChartSize({ width: 400, height: 400, outerRadius: 130 });
            }
            if (screenWidth < 470) {
                setChartSize({ width: 320, height:   270, outerRadius: 80 });
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Викликаємо при завантаженні

        return () => window.removeEventListener("resize", handleResize);
    }, [windowWidth]);

    return (
        <PieChart width={chartSize.width} height={chartSize.height} className={s.pieChartNoFocus}>
            <Pie
                data={geosData}
                cx="50%"
                cy="50%"
                outerRadius={chartSize.outerRadius}
                fill="#8884d8"
                dataKey="value"
                label={(entry) => `${entry.value}%`}
            >
                {geosData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colorList[index]} />
                ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
        </PieChart>
    );
}

export default CirclePieChart;
